import { api, call } from "../lib/api.ts";
import { ConfirmDialog } from "./ui.tsx";

/** Sends an approved driver's welcome email again. Whatever went wrong shows in the dialog. */
export function ResendWelcomeDialog({ driverId, who, onSent, onClose }: { driverId: string; who: string; onSent: () => void; onClose: () => void }) {
  return (
    <ConfirmDialog
      title="Reenviar e-mail de boas-vindas?"
      body={<>{who} recebe de novo o e-mail de boas-vindas. Fica registrado na auditoria.</>}
      confirmLabel="Reenviar"
      onConfirm={async () => {
        await call(api.admin.drivers({ id: driverId })["welcome-email"].post());
        onSent();
      }}
      onClose={onClose}
    />
  );
}
